import Section from "../section/Section";
import Title from "../Title";
import Image from "../Image";

import impactAward from "@images/impact-awards-2021.png";
import lotusAward from "@images/lotus-awards-2020.png";
import cogXAward from "@images/cogx.png";
import ukCareerDevAward from "@images/uk-career-development-awards-2020.png";
import careerTechChallengeAward from "@images/career-tech-challenge.png";
import cc from "classcat";

const Award = ({ image, status, title, className = "" }) => (
	<li className={cc(["d-flex align-items-center", className])}>
		<div className="text-center">
			{image}
			<span className="d-block text-gray-black mt-10 font-size-lg">{status}</span>
			<span className="d-block mt-2 mx-auto font-size-small" style={{ maxWidth: 175 }}>
				{title}
			</span>
		</div>
	</li>
);

const AwardWinning = () => (
	<Section className="pb-4 pb-md-9 award-winning-section-v2">
		<div className="row">
			<div className="col">
				<ul className="list-unstyled scrollbars d-flex align-items-stretch flex-nowrap pb-4">
					<Award
						image={<Image src={ukCareerDevAward} width={160} height={88} responsive={false} />}
						status="Winner"
						title="Best Use of Technology in Career Development"
						className="mr-5 mr-md-10"
					/>
					<li className="award-separator" />
					<Award
						image={<Image src={impactAward} width={175} height={58} responsive={false} />}
						status="Winner"
						title="Employment & Skills 2021"
						className="mx-5 mx-md-10"
					/>
					<li className="award-separator" />
					<Award
						image={<Image src={careerTechChallengeAward} width={175} height={46} responsive={false} />}
						status="Finalist"
						title="Nesta CareerTech Challenge Prize"
						className="mx-5 mx-md-10"
					/>
					<li className="award-separator" />
					<Award
						image={<Image src={cogXAward} width={139} height={45} responsive={false} />}
						status="Shortlisted"
						title="Global Goals Impact Award: Start Up 2021"
						className="mx-5 mx-md-10"
					/>
					<li className="award-separator" />
					<Award
						image={<Image src={lotusAward} width={175} height={53} responsive={false} />}
						status="Winner"
						title="Learning & Development 2020"
						className="ml-5 ml-md-10"
					/>
				</ul>
			</div>
		</div>
	</Section>
);

export default AwardWinning;
